import React from 'react';
const Context = React.createContext({});
const Provider = Context.Provider;
export { Context };
export default Provider;
